// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"a0de56bd","86":"f086142f","150":"fba2f361","223":"8188ac3c","453":"c6dd46dc","747":"42d8d4ff","785":"64a1f33f","787":"aa384757","811":"b40f0a4c"}[chunkId] + ".chunk.js";
};